// import package
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

// import component
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ProofForm from './ProofForm';
import IdProofConfirm from './IdProofConfirm';

// import lib
import isEmpty from '../../lib/isEmpty';

const AddressProof = () => {
    const { t, i18n } = useTranslation();

    // state
    const [ show, setShow ] = useState(false);

    // redux-state
    const { addressProof } = useSelector(state => state.userKyc);
    const { firstName, lastName, address, city, country, blockNo, postalCode } = useSelector(state => state.account);

    const checkProfileUpdate = () => {
        return !(isEmpty(firstName) || isEmpty(lastName) || isEmpty(address) || isEmpty(city) || isEmpty(country) || isEmpty(blockNo) || isEmpty(postalCode))    
    }

    const showModal = () => {
        setShow(true);
    }

    return (
        <>  
            <IdProofConfirm 
                show={show}
                onHide={ () => setShow(false)}
            />

            <div className="row align-items-center">
                <div className="col-lg-12">
                    <h3 className="dash_title mb-3">{t("ADDRESS_DOCUMENT_TITLE1")}</h3>
                </div>
            </div>
            <div className="dashboard_box">
                <div className="kycIdentityDocument">
                    <GridContainer>
                        {
                            checkProfileUpdate() && addressProof && ['new', 'rejected'].includes(addressProof.status) && <>
                                <GridItem xs={12} sm={12} md={7} lg={6}>
                                    <div className="twoFAForm">
                                        <ProofForm showModal={showModal} />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5} lg={6}>
                                    <div className="settingsNote">
                                        <h6>{t("NOTES")}</h6>
                                        {/* <p>{t("PASSWORD_TITLE")}</p> */}
                                        <ul>
                                            <li>{t("ADDRESS_DOCUMENT_DESCRIPTION1")}</li>
                                            <li>{t("ADDRESS_DOCUMENT_DESCRIPTION2")}</li>
                                            <li>{t("ADDRESS_DOCUMENT_DESCRIPTION3")}</li>
                                            {/* <li>{t("ADDRESS_DOCUMENT_DESCRIPTION4")}</li> */}
                                        </ul>
                                    </div>
                                </GridItem>
                            </>
                        }

                        {
                            addressProof && !['new', 'rejected'].includes(addressProof.status) && <GridItem xs={12} sm={12} md={12} lg={12}>
                                <div className="verifiedDocument">
                                    <h3>{t("ADDRESS_DOCUMENT_VERIFIED")}</h3>
                                    <p>{t("ADDRESS_DOCUMENT_DESCRIPTION5")} <Link to="/support-ticket">{t("SUPPORT_TEAM")}</Link></p>
                                </div>
                            </GridItem>
                        }

                        {
                            !checkProfileUpdate() && <GridItem xs={12} sm={12} md={12} lg={12}>
                                <div className="verifiedDocument">
                                    <h3 style={{'color' : 'red' }}>{t("PROFILE_MANDATORY_MSG")}</h3>
                                </div>
                            </GridItem>
                        }
                    </GridContainer>
                </div>
            </div>
        </>
    )
}

export default AddressProof;